import React from "react";
import { Dialog, DialogContent } from "@mui/material";
import { Button, Iconography, IconographySizes } from "@hid-galaxy-ui/galaxy-react";

type Props = {
  open: boolean;
  title: string;
  itemName: string;
  message: string;
  isSubmitting?: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const DeleteConfirmModal: React.FC<Props> = ({
  open,
  title,
  itemName,
  message,
  isSubmitting = false,
  onClose,
  onConfirm,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <div className="benefits-ptv-modal benefits-delete-modal">
        <header className="benefits-ptv-modal-header">
          <div className="benefits-delete-heading">
            <span className="benefits-delete-icon">
              <Iconography icon="circleExclamation" size={IconographySizes.Small} />
            </span>
            <h3>{title}</h3>
          </div>
        </header>
        <DialogContent className="benefits-ptv-modal-content">
          <p>
            {message} <strong>&quot;{itemName}&quot;</strong>. This action cannot be
            undone.
          </p>
          <div className="benefits-warning-box" role="alert">
            <Iconography icon="circleExclamation" size={IconographySizes.Medium} />
            <div>
              <h4>Warning notification</h4>
              <p>This delete can&apos;t be undone from the settings.</p>
            </div>
          </div>
        </DialogContent>
        <footer className="benefits-ptv-modal-footer">
          <Button variant="secondary" label="CANCEL" onClick={onClose} />
          <Button
            variant="primary"
            label="DELETE"
            onClick={onConfirm}
            disabled={isSubmitting}
          />
        </footer>
      </div>
    </Dialog>
  );
};

export default DeleteConfirmModal;
